import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const ReloadIcon = ({size, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '10';
			case SIZE.STANDARD:
				return '24';
			default:
				return '24';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '10';
			case SIZE.STANDARD:
				return '24';
			default:
				return '24';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M19.3538 4.73999V9.58374H14.51"
					stroke="#4C4C58"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M12.0143 19.37C10.663 19.3708 9.33745 19 8.18263 18.2983C7.0278 17.5965 6.08815 16.5907 5.4664 15.3909C4.84466 14.1911 4.56477 12.8434 4.65732 11.4952C4.74988 10.1471 5.21132 8.8503 5.99119 7.7467C6.77106 6.64311 7.83935 5.77518 9.07924 5.2378C10.3191 4.70042 11.6829 4.51429 13.0215 4.69974C14.36 4.8852 15.6218 5.43511 16.6689 6.28936C17.716 7.1436 18.5081 8.26928 18.9585 9.54334"
					stroke="#4C4C58"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</StyledSpan>
	);
};
ReloadIcon.SIZE = SIZE;
ReloadIcon.propTypes = {
	onClick: PropTypes.func,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
};

const StyledSpan = Styled.span`
	cursor: pointer;
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	align-self: center;
`;
